export default __webpack_public_path__ + "static/media/pentagon2.94f45813.png";